import React from "react";
import Button from "react-bootstrap/es/Button";
import {Col, Row} from "react-bootstrap";
import { InputWithLabel } from "../../component/Form/InputWithLabel";

class GridDashboardTemplates {
  title = "Lista de Templates do Dashboard";

  exportNewPage = true;

  showPdfButton = false;

  columns = [
    {
      Header: "Local",
      accessor: "bizLocation.friendlyName",
      HeaderColumn: true,
    },
    {
      Header: "Tipo",
      accessor: "type"
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => (
          <Row>
            <Col lg={6}>
              <a href={"/dashboard#/dashboard-templates/" + row.original.id}>
                <Button bsStyle="primary" block>Visualizar</Button>
              </a>
            </Col>
            <Col lg={6}>
              <a href={"#/dashboard-templates/" + row.original.id + "/edit"}>
                <Button bsStyle="success" block>Editar</Button>
              </a>
            </Col>
          </Row>
      ),
    }
  ];

  customFilters = { friendlyName: null }

  customFilterComponent = (props, state, onChange) => {
    return (
      <Row>
        <Col md={6}>
          <InputWithLabel label="Local" onChangeWithDelay={e => {
            this.customFilters.friendlyName = e.trim()
            onChange(this.customFilters)
          }}/>
        </Col>
      </Row>
    )
  }

  endpoint = () => {
    const params = new URLSearchParams({})
    const { friendlyName } = this.customFilters

    friendlyName && params.append('bizLocation.friendlyName', friendlyName)

    return `ton/v1/dashboard-templates?${params.toString()}`
  }
}

export default GridDashboardTemplates;



// WEBPACK FOOTER //
// ./src/customGrid/entities/DashboardTemplates.js